/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    object, string, shape, node, any, array,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { useDispatch } from 'react-redux';

import {
    PlantsCare, WhatsIncluded, ShippingDeliveryInformation, DescriptionSection,
} from './Partials';
import ProductDivider from '../ProductDivider';
import customBreakpoints from '../../../../../helpers/customBreakpoints';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

/* eslint-disable react/jsx-props-no-spreading */

function TabPanel(props) {
    const {
        children, value, index, ...other
    } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: node.isRequired,
    index: any.isRequired,
    value: any.isRequired,
};

function a11yProps(index, classes) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
        style: { flex: 'auto', maxWidth: '100%', whiteSpace: 'nowrap' },
        className: classes.tabLabel,
    };
}

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        '& .MuiTabs-scrollButtonsDesktop': {
            display: 'inline-flex',
        },
        '& span': {
            fontSize: '12px',
        },
    },
    headerContainer: {
        marginBottom: 25,
        backgroundColor: theme.palette.bgHeader,
        color: theme.palette.black,
        fontWeight: 600,
        [theme.breakpoints.down('md')]: {
            marginTop: 20,
        },
    },
    tabLabel: {
        opacity: 1,
        borderRight: '2px solid #fff',
        borderLeft: '1px solid #fff',
        '&.Mui-selected': {
            backgroundColor: '#fff',
        },
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            flex: 'none!important',
        },
        '& .MuiTab-wrapper': {
            fontSize: '0.75rem',
            fontWeight: 600,
        },
        '&:last-child': {
            borderRight: 'none',
        },
        '&:first-child': {
            borderLeft: 'none',
        },
    },
    indicatorStyle: {
        backgroundColor: '#B9E529',
        height: 5,
        position: 'absolute',
        top: 0,
    },
    plantsStyle: {
        boxShadow: 'none',
    },
});

const GraphqlProductDetailsTabs = ({
    brand,
    language,
    partNumber,
    longDescription,
    customClasses,
    dataDictionary,
    pdpDictionary,
    classes,
    careData,
}) => {
    const [value, setValue] = useState(1);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!careData.length) {
            setValue(0);
        }
    }, []);

    const infoTabArray = [
        { id: 'product_details', label: 'PRODUCT DETAILS', value: '1' },
        { id: 'product_care', label: 'PLANT CARE', value: '2' },
        { id: 'product_included', label: "WHAT'S INCLUDED", value: '3' },
        { id: 'product_shipping', label: 'SHIPPING & DELIVERY INFORMATION', value: '4' },
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
        dispatch(trackEvent({
            eventName: 'feature_interaction',
            eventCategory: 'Product Page',
            eventAction: 'Tab Click',
            eventLabel: infoTabArray[newValue].label,
        }));
    };

    const infoPanel = [
        {
            id: 'product_details',
            value: <DescriptionSection
                brand={brand}
                language={language}
                partNumber={partNumber}
                longDescription={longDescription}
                customClasses={customClasses}
                dataDictionary={dataDictionary}
                pdpDictionary={pdpDictionary}
            />,
        },
        {
            id: 'product_care',
            value: <PlantsCare careData={careData} />,
        },
        {
            id: 'product_included',
            value: <WhatsIncluded />,
        },
        {
            id: 'product_shipping',
            value: <ShippingDeliveryInformation />,
        },
    ];
    const updatedInfoTabArray = infoTabArray.filter((item) => (item.id === 'product_care' ? (item.id === 'product_care' && careData?.length) : true));
    const updatedInfoPanel = infoPanel.filter((item) => (item.id === 'product_care' ? (item.id === 'product_care' && careData?.length) : true));
    return (
        <div className={classes.root}>
            <AppBar position="static" className={`${classes.headerContainer} ${brand?.code === 'PLA' && classes.plantsStyle}`}>
                <Tabs
                    variant="scrollable"
                    scrollButtons="auto"
                    value={value}
                    onChange={handleChange}
                    TabIndicatorProps={{ className: classes.indicatorStyle }}
                    aria-label="product details tabs"
                >
                    {updatedInfoTabArray.map((item, index) =>  <Tab key={item.id} label={item.label} {...a11yProps(index, classes)} />)}
                </Tabs>
            </AppBar>
            {updatedInfoPanel.map((item, index) => <TabPanel key={item.id} value={value} index={index}>{item.value}</TabPanel>)}
            <ProductDivider />
        </div>
    );
};

GraphqlProductDetailsTabs.propTypes = {
    customClasses: object.isRequired,
    partNumber: string.isRequired,
    longDescription: string.isRequired,
    dataDictionary: object.isRequired,
    brand: shape({
        code: string.isRequired,
    }).isRequired,
    language: string.isRequired,
    pdpDictionary: string.isRequired,
    classes: object.isRequired,
    careData: array.isRequired,
};

export default withStyles(styles)(GraphqlProductDetailsTabs);
